export default __webpack_public_path__ + "static/media/Path3522.69a4bd5b.svg";